import { render, staticRenderFns } from "./DisciplinePercent.vue?vue&type=template&id=9cb90c5e&scoped=true&"
import script from "./DisciplinePercent.vue?vue&type=script&lang=js&"
export * from "./DisciplinePercent.vue?vue&type=script&lang=js&"
import style0 from "./DisciplinePercent.vue?vue&type=style&index=0&id=9cb90c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb90c5e",
  null
  
)

export default component.exports